<template>
  <div>
    <div class="row" v-if="showBand && bandAttributes.length">
      <InputAttendance
        v-for="attribute in bandAttributes"
        :key="'attendance-band-' + attribute.id_medrec_attr"
        :attribute="attribute"
        :schedule="schedule"
        :disabled="false"
        @onChange="$emit('onChange', $event)"
      />
    </div>

    <div class="row" v-if="showColumn" :style="insetStyle">
      <component
        :is="specialtyPanels[specialtyPanel]"
        v-if="specialtyPanel"
        :attributes="columnAttributes"
        :schedule="schedule"
        :disabled="false"
        @onChange="$emit('onChange', $event)"
      />
      <InputAttendance
        v-else
        v-for="attribute in columnAttributes"
        :key="'attendance-' + attribute.id_medrec_attr"
        :attribute="attribute"
        :schedule="schedule"
        :disabled="false"
        @onChange="$emit('onChange', $event)"
      />
    </div>
  </div>
</template>

<script>
import InputAttendance from './Input';
import OphthalmologyPanel from './OphthalmologyPanel.vue';
import OdontologyPanel from './OdontologyPanel.vue';
import { resolveSpecialtyPanel, splitFullWidthAttributes, PANEL_ODONTOLOGY, PANEL_OPHTHALMOLOGY } from './specialty-panel';

export default {
  name: 'AttendanceRecordForm',
  components: {
    InputAttendance,
    OphthalmologyPanel,
    OdontologyPanel,
  },
  props: {
    medicalRecord: {
      type: Object,
      required: true,
    },
    schedule: {
      type: Object,
      default: null,
    },
    recordTypes: {
      type: Array,
      default: () => [],
    },
    inset: {
      type: Boolean,
      default: false,
    },
    parts: {
      type: String,
      default: 'all',
    },
  },
  emits: ['onChange'],
  data() {
    return {
      specialtyPanels: {
        [PANEL_ODONTOLOGY]: 'OdontologyPanel',
        [PANEL_OPHTHALMOLOGY]: 'OphthalmologyPanel',
      },
    };
  },
  computed: {
    specialtyPanel() {
      return resolveSpecialtyPanel(this.schedule, this.medicalRecord, this.recordTypes);
    },
    splitAttributes() {
      return splitFullWidthAttributes(this.medicalRecord?.attributes);
    },
    bandAttributes() {
      return this.splitAttributes.band;
    },
    columnAttributes() {
      return this.splitAttributes.rest;
    },
    showBand() {
      return this.parts === 'all' || this.parts === 'band';
    },
    showColumn() {
      return this.parts === 'all' || this.parts === 'column';
    },
    insetStyle() {
      return this.inset ? 'padding-right: 12px;' : '';
    },
  },
};
</script>
